import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        toast.error('Sessão expirada. Por favor, faça login novamente.');
        window.location.pathname = '/';
      } else if (error.response.status === 403) {
        toast.error('Acesso negado. Você não tem permissão para acessar este recurso.');
        window.location.pathname = '/painel';
      } else if (error.response.status >= 500) {
        toast.error('Erro interno do servidor. Por favor, tente novamente mais tarde.');
      }
    } else {
      toast.error('Ocorreu um erro inesperado. Por favor, tente novamente.');
    }
    return Promise.reject(error);
  }
);

export default api;
